import { call, put, takeLatest } from "redux-saga/effects";
import { setLoading } from "../actions";
import { Auth } from "../utilities/auth";
import axios from "../utilities/axiosWrapper";

/**
 * @desc Update a company contact or plan administrator. The request params are
 * built by CompanyContactModel and target the shared person endpoint, so an
 * email change also propagates to Cognito.
 * @param {*} action
 * @return {*}  {Generator}
 */
export function* updateCompanyContactWorker(action: any): Generator {
	yield put(
		setLoading({ loading: true, errorMessage: "", successMessage: "" })
	);
	let apikeys: any = null;
	let jsonResponse: any = null;

	try {
		apikeys = yield Auth.getAuthTokens();
		jsonResponse = yield call(axios, action.data, apikeys);

		const status =
			jsonResponse?.status ?? jsonResponse?.response?.status ?? 0;
		const body = jsonResponse?.data ?? jsonResponse?.response?.data ?? {};

		if (status >= 200 && status < 300 && !body?.fnError) {
			return yield put(
				setLoading({
					loading: false,
					alertType: "success",
					successMessage: "Contact details successfully updated",
				})
			);
		}

		return yield put(
			setLoading({
				loading: false,
				alertType: "error",
				errorMessage:
					body?.fnError ??
					body?.error?.message ??
					"The contact could not be updated.",
			})
		);
	} catch (ex) {
		return yield put(
			setLoading({ loading: false, errorMessage: ex.message })
		);
	}
}

function* updateCompanyContactWatcher(): Generator {
	yield takeLatest("UPDATE_COMPANY_CONTACT", updateCompanyContactWorker);
}

export function* createBillingContactWorker(action: any): Generator {
	yield put(setLoading({ loading: true, errorMessage: "", successMessage: "" }));
	let apikeys: any = null;
	let jsonResponse: any = null;

	try {
		apikeys = yield Auth.getAuthTokens();
		jsonResponse = yield call(axios, {
			method: "POST",
			path: `business/${action.data.businessGuid}/billingcontacts`,
			data: {
				firstName:     action.data.firstName,
				lastName:      action.data.lastName,
				email:         action.data.email,
				mobileNumber:  action.data.mobileNumber,
				workNumber:    action.data.workNumber,
				workNumberExt: action.data.workNumberExt,
			},
		}, apikeys);

		const status = jsonResponse?.status ?? jsonResponse?.response?.status ?? 0;
		const body   = jsonResponse?.data   ?? jsonResponse?.response?.data   ?? {};

		if ((status === 200 || status === 201) && !body?.fnError) {
			return yield put(
				setLoading({ loading: false, alertType: "success", successMessage: "Billing contact added" })
			);
		}

		return yield put(
			setLoading({
				loading: false,
				alertType: "error",
				errorMessage: body?.fnError ?? body?.error?.message ?? "Could not add billing contact.",
			})
		);
	} catch (ex) {
		return yield put(setLoading({ loading: false, errorMessage: String(ex) }));
	}
}

function* createBillingContactWatcher(): Generator {
	yield takeLatest("CREATE_BILLING_CONTACT", createBillingContactWorker);
}

export { updateCompanyContactWatcher, createBillingContactWatcher };
